<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle">監査マスタ</h1>
      <div class="l-contentsBox">
        <div class="btn-basic is-inlne is-primary js-savebtn" @click="goEdit()"><a>マスタ編集画面</a></div>
      </div>
      <div class="l-contentsBox">
        <input type="file" v-on:change="fileSelected">
        <div class="btn-basic is-inlne is-primary js-savebtn" @click="fileUpload()"><a>CSVアップロード</a></div>
        <div class="btn-basic is-inlne is-primary js-savebtn" @click="templateCsvFileDownload()"><a>テンプレートCSVダウンロード</a></div>
        <br>
        <div class="l-contentsSection">
          <p class="l-text">
            テンプレートCSVをもとに、CSVによる一括取込を行うことができます。
          </p>
          <p class="l-text" style="font-weight: 600;">1.&nbsp;条No、項No、項目No</p>
          <p class="l-text">
            条No、項No、項目Noは、登録済みデータを特定するうえで必要な情報のため、不用意に編集しないようにしてください。<br>
            ・条No:<br>
            「診断条を一意に特定」するための番号。そのため、条を追加する際には「条Noが重複しないように」数値を入力する。<br>
            ・項No:<br>
            診断条に含まれる「診断項を一意に特定」するための番号。条No＋項Noの組み合わせで一意になる。<br>
            そのため、項を追加する際には「同じ条Noの中で重複しないように」数値を入力する。<br>
            ・項目No:<br>
            診断項に含まれる「診断項目を一意に特定」するための番号。条No＋項No＋項目Noの組み合わせで一意になる。<br>
            そのため、項目を追加する際には「同じ条No＋項Noの中で重複しないように」値を入力する。
          </p>
          <p class="l-text" style="font-weight: 600;">2.&nbsp;並び順</p>
          <p class="l-text">
            CSVの上から順番に並び順が設定されます。項目などを追加する際には、追加したい位置に行を追加して入力してください。
          </p>
          <p class="l-text" style="font-weight: 600;">3.&nbsp;診断コース設定</p>
          <p class="l-text">
            各診断項目の診断コース設定は、「診断コース編集画面」から個別に行なってください。
          </p>
        </div>
      </div>
      <div class="l-contentsBox" v-show="importErrorMessages">
        <span style="color: red; font-size: 1.5rem; white-space: pre-wrap; white-space: pre-line;" v-html="$sanitize(importErrorMessages)">
        </span>
      </div>
    </div>
  </main>

</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import { saveAs } from "file-saver";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isProcessing: false,
      diagMasterList: [],
      fileInfo: '',
      importErrorMessages: null
    }
  },
  created: function () {
    this.getDiagMasterList();
  },
  methods: {
    async getDiagMasterList() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/diag', {

      });
      if (res) {
        this.diagMasterList = res.data.diagMasterList;
      }
      this.isProcessing = false;
    },
    fileSelected(event) {
      this.fileInfo = event.target.files[0];
    },
    async fileUpload() {
      this.isProcessing = true;
      if (!this.fileInfo) {
        this.$toast.error('ファイルを選択してください');
        this.isProcessing = false;
        return;
      }
      const formData = new FormData()
      formData.append('file', this.fileInfo)
      let res = await this.$axios.post('/ld/api/master/diag/upload', formData);
      if (res.status === 200) {
        this.$toast.info('登録が完了しました');
      } else {
        this.$toast.error('登録時にエラーが発生しました。');
        this.importErrorMessages = res.data.message
      }
      this.fileInfo = null;
      this.isProcessing = false;
    },
    goEdit() {
      this.$store.dispatch('master/setVerId', 5);
      this.$router.push({ name: 'diag-master-edit' } );
    },
    async templateCsvFileDownload() {
      this.$toast.info('ダウンロードを開始しました。');
      await saveAs('/ld/api/master/diag/templateCsvFileDownload');
    },
  }
}
</script>